const en = {
  loginComponnent: `Login Component`,
  dashboardComponent: `Dashboard Component`,
  login: {
    email: 'Email',
    password: 'Password',
    login: 'Login',
    submit: 'Submit',
    continueWithGoogle: 'Continue with Google',
    continueWithFacebook: 'Continue with Facebook',
    continueWithApple: 'Continue with Apple',
    unableToLoginWithGoogle: 'Unable to login with Google',
    unableToLoginWithFacebook: 'Unable to login with Facebook',
    unableToLoginWithApple: 'Unable to login with Apple',
    invalidOrUnverifiedEmail: 'Invalid/Unverified email address'
  },
  dashboard: {
    logout: 'Logout',
    charities: 'Charities',
    myCharity: 'My Charity',
    donate: 'Donate',
    sendCashViaPaypal: 'Get cash via Paypal',
    sendCashToWallet: 'Get cash to wallet',
    featuredCharities: 'Featured Charities',
    charity: 'Charity',
    amount: 'Amount',
    date: 'Date',
    add: 'Add',
    chooseCharity: 'Choose Charity',
    changeCharity: 'Change Charity',
    addCharity: 'Add Charity',
    choose: 'Choose',
    donationAmount: 'Donation Amount',
    submitDonation: 'Submit Donation',
    example100: 'eg. 500',
    donationAmountError: 'Donation amount cannot be greater than your balance',
    minAmountError: 'Atleast 500 Koodos can be donated',
    min500: 'Min 500',
    min$25: 'Min $25',
    donation: 'Donation',
    koodos: 'Koodos',
    cash: 'Cash',
    shareWith: 'Share with',
    sendReceipt: 'Get tax receipt',
    none: 'None',
    focusGroup: 'Focus group',
    allSupporters: 'All supporters',
    cancel: 'Cancel',
    submit: 'Submit',
    selectiveGroup: 'Selective group',
    search: 'Search',
    getReward: 'Get Reward',
    redeemAmountError: 'Redeem amount cannot be greater than your balance',
    rewardAmount: 'Reward Amount',
    unclaimedRewardsText: 'Get your new badges and cash rewards!',
    type: 'Type',
    cashOut: 'Cash out',
    cashOutTo: 'Cash out to',
    cashOutVia: 'Cash out via',
    setupWalletText: 'Please setup your wallet first in the mobile app.',
    getCash: 'Get Cash',
    amountCannotBeZero: 'Donation amount cannot be zero',
    tellSupporters: 'Tell Your Supporters About Your Donations',
    yesAllSupporter: 'Yes, All Supporters',
    noAnonymous: 'No, Anonymous',
    chooseYourCharity: 'Choose Your Charity',
    poweredBy: 'powered by',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    wallet: 'Wallet',
    paypal: 'Paypal',
    avaiableReward: 'Available Reward',
    donateNow: 'Donate Now',
    donation: 'Donation',
    pleaseEnterFirstnameAndLastName: 'Please enter first name and last name',
    searchForYourCharity: 'Search For Your Charity',
    noCharitiesSelected: 'No charities selected',
    searchCharities: 'Search Charities'
  },
  redeem: {
    redeem: 'Redeem',
    redeemAmount: 'Redeem Amount',
    redeemNow: 'Redeem Now',
    redeemAmountError: 'Redeem amount cannot be greater than your balance',
    amount: 'Amount',
    date: 'Date',
    previousRedeem: 'Previous Redeems',
    example100: 'eg. 500',
    koodos: 'Koodos',
    cash: 'Cash',
    min500: 'Min 500',
    cashRewards: 'Cash Rewards',
    rewardsHistory: 'Rewards History',
    getReward: 'Get Reward',
    rewardAmount: 'Reward Amount',
    min$25: 'Min $25',
    cashOut: 'Cash out',
    cashOutTo: 'Cash out to',
    amountCannotBeZero: 'Donation amount cannot be zero',
  },
  error: {
    errorOccurred: 'An error occurred'
  }
};

export default en;
